class ClassWatcher {
    constructor(targetNode, classesToWatch, changeCallback) {
        this.targetNode = targetNode;
        this.classesToWatch = classesToWatch;
        this.changeCallback = changeCallback;
        this.observer = null;

        this.init();
    }

    init() {
        this.observer = new MutationObserver(this.mutationCallback);
        this.observe();
    }

    observe(includeSubtreeChildren = false) {
        const options = {
            attributes: true,
            attributeFilter: ["class"],
            attributeOldValue: true
        };
        if (includeSubtreeChildren) {
            options.subtree = true;
            options.childList = true;
        }
        this.observer.observe(this.targetNode, options);
    }

    disconnect() {
        this.observer.disconnect();
    }

    mutationCallback = mutationsList => {
        for (let mutation of mutationsList) {
            const currentClasses = _.intersection(mutation.target.classList, this.classesToWatch);
            const previousClasses = _.intersection(mutation.oldValue?.split(" "), this.classesToWatch);
            
            if (!_.isEqual(previousClasses.sort(), currentClasses.sort())) {
                this.changeCallback.call(mutation, currentClasses, previousClasses);
            }
        }
    }
}
